/* eslint-disable @typescript-eslint/naming-convention */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
  IconAdjustmentsHorizontal,
  IconAlertCircle,
  IconAlertSquare,
  IconAlertSquareRounded,
  IconAlertTriangleFilled,
  IconAnalyze,
  IconArrowMoveDown,
  IconArrowMoveUp,
  IconArrowNarrowDown,
  IconArrowNarrowLeft,
  IconArrowRight,
  IconArrowsMaximize,
  IconArrowsMinimize,
  IconBattery4,
  IconBellOff,
  IconBell,
  IconBinaryTree2,
  IconBook,
  IconBox,
  IconBulb,
  IconBus,
  IconCalendarClock,
  IconCategory,
  IconChartArrowsVertical,
  IconChartBar,
  IconChartCandle,
  IconChartDots,
  IconChartLine,
  IconCheck,
  IconChecks,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsLeft,
  IconChevronsRight,
  IconCircleCheck,
  IconCircleFilled,
  IconCircleX,
  IconCircuitBattery,
  IconClock,
  IconClockHour4,
  IconCopyPlus,
  IconCpu,
  IconCube,
  IconDashboard,
  IconDatabaseCog,
  IconDeviceFloppy,
  IconDiamond,
  IconDirections,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconExclamationCircle,
  IconExternalLink,
  IconEye,
  IconFileAnalytics,
  IconFileArrowLeft,
  IconFilter,
  IconFilterPlus,
  IconFlag,
  IconFocusCentered,
  IconFold,
  IconGripVertical,
  IconHeartRateMonitor,
  IconHierarchy2,
  IconHome,
  IconInfoCircle,
  IconInfoSquare,
  IconKey,
  IconLayoutDashboard,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarRightCollapse,
  IconLock,
  IconLockOpen2,
  IconLogout,
  IconMail,
  IconMailX,
  IconMessage,
  IconMessagePlus,
  IconMessages,
  IconMessagesOff,
  IconMinus,
  IconPassword,
  IconPencil,
  IconPlayerPlay,
  IconPlus,
  IconPointFilled,
  IconProgress,
  IconRectangleFilled,
  IconRelationOneToMany,
  IconReload,
  IconRestore,
  IconSearch,
  IconSelector,
  IconServer,
  IconSettings,
  IconSortDescending,
  IconSquareChevronsDown,
  IconSquareChevronsUp,
  IconSwitchHorizontal,
  IconTag,
  IconTool,
  IconTournament,
  IconTrash,
  IconTriangleFilled,
  IconUrgent,
  IconUser,
  IconUserCircle,
  IconUserCog,
  IconWifi,
  IconWifiOff,
  IconWorld,
  IconX,
  IconZoomQuestion,
  IconArrowNarrowRight,
  IconTransferIn,
  IconBellRinging,
  IconReportSearch,
  IconListCheck,
} from 'angular-tabler-icons/icons';
import { CustomIconModule } from '../icon/custom-icon.module';
import { SvgComponent } from './svg-icon.component';
import { IconAlertTriangle } from './tabler-icon-override/alert-triangle';

const tablerIcons = {
  IconAdjustmentsHorizontal,
  IconAlertCircle,
  IconAlertSquare,
  IconAlertSquareRounded,
  IconAlertTriangle,
  IconAlertTriangleFilled,
  IconAnalyze,
  IconArrowMoveDown,
  IconArrowMoveUp,
  IconArrowNarrowDown,
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconArrowRight,
  IconArrowsMaximize,
  IconArrowsMinimize,
  IconMessage,
  IconBattery4,
  IconBellOff,
  IconBell,
  IconBinaryTree2,
  IconBook,
  IconBox,
  IconBulb,
  IconBus,
  IconCalendarClock,
  IconCategory,
  IconChartArrowsVertical,
  IconChartBar,
  IconChartCandle,
  IconChartDots,
  IconChartLine,
  IconCheck,
  IconChecks,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsLeft,
  IconChevronsRight,
  IconCircleCheck,
  IconCircleFilled,
  IconCircleX,
  IconCircuitBattery,
  IconClock,
  IconClockHour4,
  IconCpu,
  IconCube,
  IconDashboard,
  IconDatabaseCog,
  IconDiamond,
  IconDirections,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconExclamationCircle,
  IconExternalLink,
  IconEye,
  IconFileAnalytics,
  IconFilter,
  IconFilterPlus,
  IconFlag,
  IconFocusCentered,
  IconFold,
  IconGripVertical,
  IconHeartRateMonitor,
  IconHome,
  IconInfoCircle,
  IconInfoSquare,
  IconKey,
  IconLayoutDashboard,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarRightCollapse,
  IconLock,
  IconLockOpen2,
  IconLogout,
  IconMail,
  IconMailX,
  IconMessagePlus,
  IconMessages,
  IconMessagesOff,
  IconMinus,
  IconPassword,
  IconPencil,
  IconPlayerPlay,
  IconPlus,
  IconPointFilled,
  IconProgress,
  IconRectangleFilled,
  IconRelationOneToMany,
  IconReload,
  IconRestore,
  IconSearch,
  IconSelector,
  IconServer,
  IconSettings,
  IconSortDescending,
  IconSwitchHorizontal,
  IconTag,
  IconTournament,
  IconTrash,
  IconTriangleFilled,
  IconUrgent,
  IconUser,
  IconUserCircle,
  IconUserCog,
  IconWifi,
  IconX,
  IconZoomQuestion,
  IconSquareChevronsDown,
  IconSquareChevronsUp,
  IconDeviceFloppy,
  IconCopyPlus,
  IconWifiOff,
  IconFileArrowLeft,
  IconTool,
  IconHierarchy2,
  IconWorld,
  IconTransferIn,
  IconBellRinging,
  IconReportSearch,
  IconListCheck,
};

@NgModule({
  declarations: [SvgComponent],
  imports: [CommonModule, CustomIconModule, MatIconModule, TablerIconsModule.pick(tablerIcons)],
  exports: [SvgComponent],
})
export class SvgIconModule {}
